import React, { useState, useEffect } from 'react';
import './EmiCalculator.css'; // Optional: create this CSS file if you want to customize styles
import Seo from "../components/Seo";



const EmiCalculator = () => {
  const [loanAmount, setLoanAmount] = useState(5000000);
  const [interestRate, setInterestRate] = useState(8.5);
  const [loanTenure, setLoanTenure] = useState(20);
  const [emi, setEmi] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);

  useEffect(() => {
    const principal = loanAmount;
    const monthlyInterestRate = interestRate / 100 / 12;
    const numberOfMonths = loanTenure * 12;

    const emiCalc =
      (principal * monthlyInterestRate * Math.pow(1 + monthlyInterestRate, numberOfMonths)) /
      (Math.pow(1 + monthlyInterestRate, numberOfMonths) - 1);

    const totalPay = emiCalc * numberOfMonths;
    const interestPay = totalPay - principal;

    setEmi(emiCalc.toFixed(0));
    setTotalInterest(interestPay.toFixed(0));
    setTotalPayment(totalPay.toFixed(0));
  }, [loanAmount, interestRate, loanTenure]);

  return (
    <>

     <Seo
        title="EMI Calculator - Calculate Your Loan EMI Instantly | Mortbuzz"
        description="Use Mortbuzz's EMI Calculator to find out your monthly loan repayments for home loans, car loans, business loans, personal loans, and more. Quick and accurate results."
        keywords="EMI calculator, loan EMI calculator, home loan EMI, car loan EMI, personal loan EMI, business loan EMI, loan repayment calculator, Mortbuzz"
        canonical="https://www.mortbuzz.in/emi-calculator"
      />
  

    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="calculator-box bg-dark text-light p-4 rounded shadow">
            <h2 className="text-center mb-4">Home Loan EMI Calculator</h2>

            {/* Loan Amount */}
            <div className="mb-4">
              <label htmlFor="loanAmount" className="form-label">Loan Amount (₹)</label>
              <input
                type="range"
                className="form-range"
                id="loanAmount"
                min="500000"
                max="50000000"
                step="100000"
                value={loanAmount}
                onChange={(e) => setLoanAmount(Number(e.target.value))}
              />
              <span className="slider-value d-block">{`₹${loanAmount.toLocaleString()}`}</span>
            </div>

            {/* Interest Rate */}
            <div className="mb-4">
              <label htmlFor="interestRate" className="form-label">Interest Rate (%)</label>
              <input
                type="range"
                className="form-range"
                id="interestRate"
                min="5"
                max="20"
                step="0.1"
                value={interestRate}
                onChange={(e) => setInterestRate(Number(e.target.value))}
              />
              <span className="slider-value d-block">{`${interestRate}%`}</span>
            </div>

            {/* Loan Tenure */}
            <div className="mb-4">
              <label htmlFor="loanTenure" className="form-label">Loan Tenure (Years)</label>
              <input
                type="range"
                className="form-range"
                id="loanTenure"
                min="1"
                max="30"
                value={loanTenure}
                onChange={(e) => setLoanTenure(Number(e.target.value))}
              />
              <span className="slider-value d-block">{`${loanTenure} Years`}</span>
            </div>

            {/* Results */}
            <div className="result-box text-center border-top pt-4 mt-4">
              <h3 className="emi-amount text-success mb-3">EMI: ₹{emi}</h3>
              <div className="row text-light">
                <div className="col-md-4">
                  <p className="mb-1">Total Interest</p>
                  <h5>₹{Number(totalInterest).toLocaleString()}</h5>
                </div>
                <div className="col-md-4">
                  <p className="mb-1">Total Payment</p>
                  <h5>₹{Number(totalPayment).toLocaleString()}</h5>
                </div>
                <div className="col-md-4">
                  <p className="mb-1">Loan Period</p>
                  <h5>{loanTenure} Years</h5>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    </>
  );
};

export default EmiCalculator;
